@if (isTopLevelGroup$()) {
  <div class="sol-navbar-menu-group">
    <div class="sol-navbar-menu-title">
      {{ text$() | translate }}
    </div>

    <ng-container [ngTemplateOutlet]="children" />
  </div>
} @else {
  <button
    [class]="buttonClasses$()"
    (click)="onClick($event)"
    (auxclick)="onClick($event, true)"
    (mouseenter)="onHoverPreview($event)"
  >
    @if (prependIcon$() && level$() < 2) {
      <sol-icon class="sol-button-part-icon" [name]="prependIcon$()" />
    } @else if (level$() < 2) {
      <span class="navbar-menu-button-spacer"></span>
    }
    <span class="sol-navbar-menu-button-text">{{ text$() | translate }}</span>

    @if (isMenuGroup$()) {
      <sol-icon class="sol-button-part-icon" [name]="appendIcon$()" />
    }
  </button>

  @if (expanded$() && isMenuGroup$()) {
    <div class="sol-navbar-menu-group-items">
      <ng-container [ngTemplateOutlet]="children" />
    </div>
  }
}

<ng-template #children>
  @for (child of children$(); track child.id) {
    <sol-navbar-item
      [item]="child"
      [activeRouteIds]="activeRouteIds$()"
      [level]="level$() + 1"
      [expandedIds]="expandedIds$()"
      (expanded)="onExpanded($event)"
      (hoverPreview)="onHoverPreviewFromChild($event)"
      (hoverPreviewClose)="onHoverPreviewClose()"
    />
  }
</ng-template>
